import PuzzleService from '_services/rest/modules/puzzle';

export default {
  state: {
    puzzleFences: null,
    hasChanges: false,
    enableExport: true,
  },
  mutations: {
    setPuzzleFences(state, puzzleFences) {
      state.puzzleFences = puzzleFences;
    },
    setHasChanges(state, status) {
      state.hasChanges = status;
    },
    setEnableExport(state, status) {
      state.enableExport = status;
    },
  },
  actions: {
    setPuzzleFences({ commit }, model) {
      commit('setPuzzleFences', model);
    },
    setHasChanges({ commit }, status) {
      commit('setHasChanges', status);
    },
    setEnableExport({ commit }, status) {
      commit('setEnableExport', status);
    },
    getPuzzleFences({ commit }, id) {
      PuzzleService.getPuzzleById(id)
        .then(response => {
          commit('setPuzzleFences', response);
          commit('setHasChanges', false);
        });
    },
  },
};
